import * as React from 'react';
import { format } from 'date-fns';
import { faGifts } from '@fortawesome/pro-regular-svg-icons';

import { IIndexedOrder } from 'src/graphql/types';
import { Template } from '../Template';

interface Props {
  item: IIndexedOrder;
}

export const EGiftPurchaseOrder = ({ item }: Props) => {
  const title = (
    <div className="d-flex flex-row justify-content-between w-100">
      <span>E-Gift Order #{item.id}</span>
      <span>{format(new Date(item.completedAt), 'MMM d, y')}</span>
    </div>
  );

  return (
    <Template icon={faGifts} title={title}>
      <div className="text-truncate mt-1">
        <div className="mb-2">
          <strong className="d-block">Purchaser:</strong>
          <div>{item.purchaserName}</div>
          <div>{item.purchaserEmail}</div>
        </div>
        <div className="mb-2">
          <strong className="d-block">Recipient:</strong>
          <div>{item.egiftRecipientName}</div>
          <div>{item.egiftRecipientEmail}</div>
        </div>
      </div>
    </Template>
  );
};
